import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-react/layouts/dashboardStyle.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";
import logo from "assets/img/KrikeyFullwordLogo.png";
import Navbar from "components/Navbars/Navbar.jsx";


const Admin = ({ classes, children, ...rest }) => (
  <div className={classes.wrapper} >
    <Sidebar
      logoText={"Admin"}
      logo={logo}
      color={'blue'}
      classes={classes}
      {...rest}
    />

    <div className={classes.mainPanel} >
      <Navbar
        {...rest}
      />
      <div className={classes.content}>
        <div className={classes.container}>{children}</div>
      </div>
    </div>
  </div>
);

export default withStyles(dashboardStyle)(Admin);